var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHailstorm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.199 13a5.413 5.413 0 0 0-.652 2.576C13.547 16.926 15 18 15 19.875c0 1.25-.852 2.291-2.555 3.125.565-1.17.74-2.212.526-3.125-.32-1.37-2.695-2.983-3.368-4.299-.45-.877-.648-1.736-.595-2.576zm3.301 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-9-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-5-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm17-1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-14-2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM13.281 1c2.296 0 4.156 1.968 4.156 4.395 0 .214-.014.423-.042.628h.117a3.488 3.488 0 0 1 0 6.977H5.488a3.488 3.488 0 0 1 0-6.977h.074c0-1.387 1.064-2.511 2.375-2.511.525 0 1.01.18 1.403.484l.01-.028C9.91 2.24 11.457 1 13.28 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHailstorm);
export default __webpack_public_path__ + "static/media/hailstorm.04126331eb41d538241213ccb4dfd50e.svg";
export { ForwardRef as ReactComponent };